export const tryToLoadImage = (url: string) =>
	new Promise((resolve, reject) => {
		const img = new Image();
		img.onerror = () => {
			reject(new Error(`Failed to load image: ${url}`));
		};
		img.onload = () => {
			resolve('ok');
		};
		img.src = url;
	});
